'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _documentOffset = require('document-offset');

var _documentOffset2 = _interopRequireDefault(_documentOffset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        _this.state = {
            hidden: true,
            position: props.position
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'componentWillUnmount', this).call(this);
            clearTimeout(this._removeTimeout);
            return this;
        }
    }, {
        key: 'getPosition',
        value: function getPosition() {
            var elWidth = void 0,
                offset = void 0,
                hintWidth = void 0,
                hintHeight = void 0,
                position = this.props.position;

            offset = (0, _documentOffset2.default)(this.root);
            hintWidth = this.hint.offsetWidth;
            hintHeight = this.hint.offsetHeight;

            elWidth = this.root.offsetWidth;

            // нет места снизу
            if (offset && offset.top + hintHeight + 18 > this.state.docH) {
                if (position === 'left-top') {
                    position = 'left-bottom';
                } else if (position === 'right-top') {
                    position = 'right-bottom';
                } else if (position === 'bottom-right') {
                    position = 'top-right';
                } else if (position === 'bottom-left') {
                    position = 'top-left';
                }
            }

            // нет места сверху
            if (offset && offset.top - hintHeight - 18 <= 0) {
                if (position === 'top-right') {
                    position = 'bottom-right';
                } else if (position === 'top-left') {
                    position = 'bottom-left';
                } else if (position === 'right-bottom') {
                    position = 'right-top';
                } else if (position === 'left-bottom') {
                    position = 'left-top';
                }
            }

            // нет места справа
            if (offset && offset.left + elWidth + hintWidth + 18 > this.state.docW) {
                if (position === 'right-bottom') {
                    position = 'left-bottom';
                } else if (position === 'right-top') {
                    position = 'left-top';
                } else if (position === 'top-left') {
                    position = 'top-right';
                } else if (position === 'bottom-left') {
                    position = 'bottom-right';
                }
            }

            // нет места слева
            if (offset && offset.left - (elWidth + hintWidth + 18) <= 0) {
                if (position === 'top-right') {
                    position = 'top-left';
                } else if (position === 'bottom-right') {
                    position = 'bottom-left';
                } else if (position === 'left-top') {
                    position = 'right-top';
                } else if (position === 'left-bottom') {
                    position = 'right-bottom';
                }
            }

            return position;
        }
    }, {
        key: '_handleMouseLeave',
        value: function _handleMouseLeave() {
            var _this2 = this;

            this._removeTimeout = setTimeout(function () {
                return _this2.setState({ hidden: true });
            }, 100);
            return this;
        }
    }, {
        key: '_handleMouseEnter',
        value: function _handleMouseEnter() {
            var _this3 = this;

            clearTimeout(this._removeTimeout);

            this.setState({
                hidden: false,
                docH: window.document.documentElement.offsetHeight,
                docW: window.document.documentElement.offsetWidth
            }).then(function () {
                return _this3.setState({ position: _this3.getPosition() });
            });

            return this;
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.dark) + String(this.props.inline) + String(this.props.multiLine) + String(this.props.short) + String(this.props.middle) + String(this.props.long) + String(this.props.wide) + String(this.state.position);
        }
    }, {
        key: '_hintRef',
        value: function _hintRef(el) {
            this.hint = el;
        }
    }, {
        key: '_rootRef',
        value: function _rootRef(el) {
            this.root = el;
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    // components label
    label: '',
    // components root HTMLElement
    component: 'div',
    // default position
    position: 'right-top',
    dark: false,
    inline: false,
    short: false,
    middle: false,
    long: false,
    wide: false,
    multiLine: true
};
Main.propTypes = {
    dark: _propTypes2.default.bool,
    labelClassName: _propTypes2.default.string,
    children: _propTypes2.default.any.isRequired,
    label: _propTypes2.default.any.isRequired,
    inline: _propTypes2.default.bool,
    wide: _propTypes2.default.bool,
    long: _propTypes2.default.bool,
    middle: _propTypes2.default.bool,
    short: _propTypes2.default.bool
};
Main.displayName = 'Hint';
exports.default = Main;